import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import RedbookView from '../components/RedbookView';

const Redbook = () => {
  return (
    <Layout>
      <div className="mb-4">
        <Link to="/dashboard" className="text-blue-600 hover:underline text-sm">
          &larr; Back to Dashboard
        </Link>
      </div>
      <h1 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8 text-center">
        By the Numbers: Tracking Connecticut's Economic Competitiveness
      </h1>
      <RedbookView />
    </Layout>
  );
};

export default Redbook;
